<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'locationInfo'
}
</script>

<style>

</style>
